/* @flow */

import * as React from 'react';
import Moment from 'react-moment';

import type { TypeRenderProps } from './types';

export default function formattedDate(): React.ComponentType<TypeRenderProps> {
  return function FormattedDateField({ display }: TypeRenderProps) {
    // const dateTimeArray = display.split(' ');
    // const d: Date = new Date(dateTimeArray[0]);
    return display ? <Moment date={display} format="MMMM DD, YYYY" /> : '-';
  };
}
